import React, { useEffect } from 'react';
import WOW from 'wow.js';

function AboutOne() {
    useEffect(() => {
        const wow = new WOW({
            boxClass: 'wow',
            animateClass: '',
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
    }, []);

    return (
        <div>

            {/* rts about us section start */}
            <div className="rts-about-area rts-section-gap bg-about-sm-shape">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        
                        {/* LEFT CONTENT */}
                        <div className="col-lg-6 col-md-12 col-sm-12 order-lg-1 order-md-2 order-2 mt_md--50 mt_sm--50">
                            
                            {/* TITLES */}
                            <div className="rts-title-area">
                                <p className="pre-title">Sobre a GBSP Partners</p>
                                <h2 className="title">
                                    Um ecossistema completo em soluções financeiras e estratégicas
                                </h2>
                            </div>

                            {/* TEXT */}
                            <div className="about-inner">
                                <p className="disc">
                                    O GB Grupo é uma plataforma integrada de soluções financeiras e estratégicas
                                    que atua nacionalmente conectando empresas, produtores rurais e indivíduos às
                                    melhores oportunidades do mercado. Com mais de 35 anos de experiência no
                                    sistema bancário e financeiro, unimos unidades especializadas que trabalham de maneira
                                    consultiva e complementar para entregar desempenho, segurança e crescimento sustentável.
                                </p>

                                {/* BULLET POINTS */}
                                <div className="row about-success-wrapper">

                                    <div className="col-lg-6 col-md-6">
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Atuação Consultiva Completa</p>
                                        </div>
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Mais de 35 anos de experiência real</p>
                                        </div>
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Especialistas em crédito e inteligência</p>
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6">
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Soluções para empresas e agronegócio</p>
                                        </div>
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Análises estratégicas avançadas</p>
                                        </div>
                                        <div className="single">
                                            <i className="far fa-check" />
                                            <p className="details">Consultoria segura e transparente</p>
                                        </div>
                                    </div>
                                </div>

                                {/* FOUNDER BLOCK */}
                                <div className="row about-founder-wrapper align-items-center mt--40">

                                    {/* LEFT */}
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="author-inner">
                                            <a className="thumbnail" href="#">
                                                <img
                                                    src="assets/images/about/sm-01.png"
                                                    alt="gb_founder"
                                                />
                                            </a>
                                            <div className="founder-details">
                                                <h6 className="title">Gilson Borges</h6>
                                                <span>Fundador do GB Grupo</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* RIGHT */}
                                    <div className="col-lg-6 col-md-6 col-sm-6 mt_sm--20">
                                        <div className="author-call-option">
                                            <img
                                                className="authore-call"
                                                src="assets/images/about/call.svg"
                                                alt="call"
                                            />
                                            <div className="call-details">
                                                <span>Fale com um Especialista</span>
                                                <a href="linkwhats">
                                                    <h6 className="title">WhatsApp Disponível</h6>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* END FOUNDER BLOCK */}

                            </div>
                        </div>

                        {/* RIGHT IMAGE AREA */}
                        <div className="col-lg-6 col-md-12 col-sm-12 order-lg-2 order-md-1 order-1">
                            <div className="about-one-thumbnail">
                                <img
                                    src="assets/images/home/2.png"
                                    alt="about-gb"
                                />
                                <img
                                    className="small-img"
                                    src="assets/images/home/3.png"
                                    alt="about-small"
                                />
                                <div className="experience">
                                    <div className="left single">
                                        <h2 className="title">35+</h2>
                                        <p className="time">Anos</p>
                                    </div>
                                    <div className="right single">
                                        <p className="disc">De experiência em soluções financeiras e consultivas</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* rts about us section end */}

        </div>
    );
}

export default AboutOne;
